import React from 'react';
import { motion } from 'framer-motion';
import { Cookie } from '../types';
interface CookieCardProps {
  cookie: Cookie;
  quantity: number;
  onAdd: (cookie: Cookie) => void;
  onRemove: (cookieId: string) => void;
}
export function CookieCard({
  cookie,
  quantity,
  onAdd,
  onRemove
}: CookieCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5
  }} className="flex flex-col h-full bg-white/20 backdrop-blur-xl border border-white/30 rounded-[24px] p-6 shadow-glass hover:shadow-2xl transition-all duration-300" data-id="element-24">
      <div className="relative w-full aspect-square rounded-[16px] overflow-hidden mb-6 bg-brand-pink/50 flex items-center justify-center" data-id="element-25">
        {cookie.image ? <img src={cookie.image} alt={cookie.name} className="w-full h-full object-cover" data-id="element-26" /> : <div className="w-32 h-32 rounded-full bg-gradient-to-br from-brand-purple/20 to-brand-purple/5 flex items-center justify-center shadow-inner" data-id="element-27">
            <span className="text-4xl" data-id="element-28">🍪</span>
          </div>}
      </div>

      <div className="flex-grow flex flex-col" data-id="element-29">
        <h3 className="text-2xl font-bold text-brand-purple mb-3 font-serif leading-tight" data-id="element-30">
          {cookie.name}
        </h3>
        <p className="text-brand-purple/80 text-sm mb-6 flex-grow leading-relaxed" data-id="element-31">
          {cookie.description}
        </p>

        {quantity > 0 ? <div className="flex items-center justify-between bg-white/40 rounded-full p-1.5 shadow-sm border border-white/50" data-id="element-32">
            <button onClick={() => onRemove(cookie.id)} className="w-10 h-10 rounded-full bg-white text-brand-purple font-bold flex items-center justify-center hover:bg-brand-purple hover:text-white transition-colors shadow-sm" aria-label="Remove one" data-id="element-33">
              -
            </button>
            <span className="font-bold text-brand-purple px-4 text-lg" data-id="element-34">
              {quantity} in box
            </span>
            <button onClick={() => onAdd(cookie)} className="w-10 h-10 rounded-full bg-brand-purple text-white font-bold flex items-center justify-center hover:bg-brand-purple/90 transition-colors shadow-sm" aria-label="Add one" data-id="element-35">
              +
            </button>
          </div> : <button onClick={() => onAdd(cookie)} className="w-full py-3.5 rounded-full font-bold text-sm tracking-wide uppercase transition-all duration-300 shadow-md bg-brand-purple text-white hover:bg-brand-purple/90 hover:scale-[1.02]" data-id="element-36">
            Add to Box
          </button>}
      </div>
    </motion.div>;
}